import { Input } from "@mui/material"
import { FC, useEffect, useState } from "react"

interface IProps {
  inputValue: number | string
  disabled: boolean
  updateStageData: (val: number | string) => void
}

const MyStageInput: FC<IProps> = ({
  inputValue,
  updateStageData,
  disabled,
}) => {
  const [value, setValue] = useState<number | string>("")

  useEffect(() => {
    setValue(inputValue)
  }, [])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    if (/^[0-9]*$/.test(newValue)) {
      setValue(newValue)
    }
  }

  const onKeyDown = (e: any) => {
    if (e.keyCode === 27 || e.keyCode === 13) {
      updateStageData(Number(e.target.value))
    }
  }

  return (
    <Input
      className="stage-input"
      value={value}
      type="number"
      disabled={disabled}
      disableUnderline={true}
      onChange={handleChange}
      onKeyDown={onKeyDown}
    />
  )
}

export default MyStageInput
